import { useState, useMemo } from 'react'

import {
	EuiButton,
	EuiTitle,
	EuiFieldSearch,
	EuiPanel,
	EuiFlexGroup,
	EuiFlexItem,
	EuiSpacer,
} from '@equipmentshare/ds2'

import DataGrid from 'views/components/DataGrid'

import createColumns from './columns'
import { GroupQuery, Resource } from 'graphql'
import { getResourceString } from '../../../components/resource'

type ResourcePolicy = GroupQuery['group']['policies'][number]

/** A policy row, once the query's nullable entries are filtered out. */
export type PolicyRow = NonNullable<ResourcePolicy>

type Props = {
  onAddPolicyClick: any,
  policies: ResourcePolicy[],
	isLoading: boolean,
  onRemovePolicyClick: any,
}

export default function GroupPoliciesTable( { isLoading, onAddPolicyClick, policies, onRemovePolicyClick }: Props ) {
	const [ search, setSearch ] = useState( '' )
	const columns = createColumns( onRemovePolicyClick )

	const onSearchChange = ( event: React.ChangeEvent<HTMLInputElement> ) => setSearch( event.currentTarget.value )

	const filteredPolicies = useMemo( () => {
		const rows = policies.filter( ( p ): p is PolicyRow => p !== null )
		if ( search === '' ) {
			return rows
		}
		const lowerCaseSearch = search.toLowerCase()
		return rows.filter( ( p ) => p.role.name.toLowerCase().includes( lowerCaseSearch ) || getResourceString( p.resource as Resource ).toLowerCase().includes( lowerCaseSearch ) )
	}, [ policies, search ] )

	return (
		<>
			<EuiFlexGroup alignItems="center" gutterSize="xl">
				<EuiFlexItem grow={false}>
					<EuiTitle size="s"><h2>Policies</h2></EuiTitle>
				</EuiFlexItem>
				<EuiFlexItem grow={false}>
					<EuiButton
						color="text"
						onClick={onAddPolicyClick}
						size="s"
						iconType="plus"
					>
						Add policy
					</EuiButton>
				</EuiFlexItem>
			</EuiFlexGroup>
			<EuiSpacer size="m" />
			<EuiFieldSearch
				value={search}
				onChange={onSearchChange}
				placeholder="Search policies"
			/>
			<EuiSpacer />
			<EuiPanel paddingSize="none" className="eui-yScroll" hasShadow={false}>
				<DataGrid
					isLoading={isLoading}
					emptyStateText="No policies found."
					columns={columns}
					rows={filteredPolicies}
				/>
			</EuiPanel>
		</>
	)
}
